import React, { PropTypes } from 'react';
import TwoColumnRow from '../../../tc-ui/two-column-row';
import EditButton from '../../generic-components/edit-button';
import MouseOverEditDiv from '../../../tc-ui/mouse-over-edit-div';
import AddItemCard from '../../generic-components/add-item-card/add-item-card';
import HelperLink from '../product/helper-link';

const CheckinCheckout = ({
 inMaster,
 openAddEditContractDialog,
 supplierEditable,
 classes = {},
 inDiffing,
 ...data,
}) => {
  const {
    checkIn,
    checkOut,
    earlyCheckIn,
    earlyCheckInFee,
    earlyCheckInCostType,
    earlyCheckInPercentageType,
    lateCheckOut,
    lateCheckOutFee,
    lateCheckOutCostType,
    lateCheckOutPercentageType,
  } = data;
  if (!checkIn && !checkOut && !earlyCheckIn && !earlyCheckInFee && !lateCheckOut && !lateCheckOutFee) {
    return (
      <div
        style={{ marginLeft: 'calc(15% + 32px)', width: 'calc(80% - 32px)', marginBottom: '24px' }}
        id="checkInCheckOut"
      >
        <HelperLink value="checkinout" justLabel={inMaster}>
          Check-in and Check-out Policy
        </HelperLink>
        <AddItemCard text={`Add check-in and check-out\npolicy`} onClick={() => openAddEditContractDialog({
          type: 'checkInOut',
          title: 'Edit Check-in & Check-out Policy',
        })} editable={supplierEditable}
        />
      </div>
    );
  }
  return (
    <div
      style={{
        margin: inDiffing ? 0 : `0 0 0 calc(15% + 32px)`,
        whiteSpace: 'pre-wrap',
        width: 'calc(80% - 32px)',
      }}
      id="checkInCheckOut"
    >
      <HelperLink
        value="checkinout"
        labelText="Check-in and Check-out Policy"
        justLabel={inMaster}
      />
      {supplierEditable && (<br/>)}
      <MouseOverEditDiv
        editable={supplierEditable}
        actionButtons={<EditButton onEdit={() => openAddEditContractDialog({
          type: 'checkInOut',
          title: 'Edit Check-in & Check-out policy',
        })}
        />}
      >
        <TwoColumnRow
          outerContainerStyle={{ width: '100%', marginBottom: '12px', display: 'flex' }}
          leftColumnStyle={{ width: '50%', float: 'none' }}
          leftColumnContent={
            <div>
              <div style={{ fontWeight: 'bold' }}>Check-in policy</div>
              <div
                style={{ fontWeight: 'bold', fontSize: '18px', margin: '8px auto', color: 'black' }}
                className={classes['checkIn']}
              >
                {checkIn}
              </div>
              {
                earlyCheckIn ? (
                  <div>
                    <small>EARLY CHECK-IN</small>
                    <div>Available</div>
                    <div className={classes['earlyCheckIn']}>From {earlyCheckIn}</div>
                    <div className={classes['earlyCheckInFee'] || classes['earlyCheckInCostType'] || classes['earlyCheckInPercentageType']}>
                      { earlyCheckInFee ? `For ${earlyCheckInCostType === '%' ? `${earlyCheckInFee}${earlyCheckInCostType}` : `${earlyCheckInCostType || '$'}${earlyCheckInFee}`} ${earlyCheckInCostType === '%' ? earlyCheckInPercentageType : ''}` : undefined }
                    </div>
                  </div>
                ) : (
                  <div>
                    <small>EARLY CHECK-IN</small>
                    <div className={classes['earlyCheckIn']}>Not Available</div>
                  </div>
                )
              }
            </div>
          }
          rightColumnStyle={{ marginLeft: '10%', width: '50%', float: 'none' }}
          rightColumnContent={
            <div>
              <div style={{ fontWeight: 'bold' }}>Check-out policy</div>
              <div
                style={{ fontWeight: 'bold', fontSize: '18px', margin: '8px auto', color: 'black' }}
                className={classes['checkOut']}
              >
                {checkOut}
              </div>
              {
                lateCheckOut ? (
                  <div>
                    <small>LATE CHECK-OUT</small>
                    <div>Available</div>
                    <div className={classes['lateCheckOut']}>Until {lateCheckOut}</div>
                    <div className={classes['lateCheckOutFee'] || classes['lateCheckOutCostType'] || classes['lateCheckOutPercentageType']}>
                      { lateCheckOutFee ? `For ${lateCheckOutCostType === '%' ? `${lateCheckOutFee}${lateCheckOutCostType}` : `${lateCheckOutCostType || '$'}${lateCheckOutFee}`} ${lateCheckOutCostType === '%' ? lateCheckOutPercentageType : ''}` : undefined }
                    </div>
                  </div>
                ) : (
                  <div>
                    <small>LATE CHECK-OUT</small>
                    <div className={classes['lateCheckOut']}>Not Available</div>
                  </div>
                )
              }
            </div>
          }
        />
      </MouseOverEditDiv>
    </div>
  );
};

CheckinCheckout.propTypes = {
  checkIn: PropTypes.any,
  checkOut: PropTypes.any,
  earlyCheckIn: PropTypes.any,
  earlyCheckInFee: PropTypes.any,
  lateCheckOut: PropTypes.any,
  lateCheckOutFee: PropTypes.any,
  openAddEditContractDialog: PropTypes.func,
};

export default CheckinCheckout;



// WEBPACK FOOTER //
// ./src/app/components/contracting/contract-activities-products/contract-policies/checkinout.jsx